import { render, staticRenderFns } from "./FeatureSection.vue?vue&type=template&id=adb70dca&scoped=true&"
import script from "./FeatureSection.vue?vue&type=script&lang=js&"
export * from "./FeatureSection.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSection.vue?vue&type=style&index=0&id=adb70dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb70dca",
  null
  
)

export default component.exports